<template>
  <div>
    <v-img  alt="" contain class="favourite__logo" src="@/assets/redcar/page-headers/favourites.png" />

    <v-container>
      <p class="px-4 py-6 no-favourites" v-html="hubbdata.favourites.labels.text" v-if="!favourites.length"></p>

      <v-expansion-panels role="region">
        <v-expansion-panel @click="scrollToTop()" ripple v-if="events.length" class="mb-2">
          <v-expansion-panel-header>
            <template v-slot:actions>
              <v-icon color="dark">mdi-chevron-down</v-icon>
            </template>
            {{hubbdata.home.labels.events}}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-for="(favourite, idx) in events" :key="idx">
              <EventItem
                v-if="favourite.type != null && favourite.type == 'event'"
                :event="favourite"
                :eventIdx="idx"
              />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel @click="scrollToTop()" ripple v-if="opportunitys.length" class="mb-2">
          <v-expansion-panel-header>
            <template v-slot:actions>
              <v-icon color="dark">mdi-chevron-down</v-icon>
            </template>
            {{hubbdata.home.labels.apprenticeships}}
          </v-expansion-panel-header>
          <v-expansion-panel-content class="px-0">
            <div v-for="(favourite, idx) in opportunitys" :key="idx">
              <OpportunityItem
                v-if="favourite.type != null && favourite.type == 'opportunity'"
                :key="idx"
                :opportunity = favourite
              />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel @click="scrollToTop()" ripple v-if="organisations.length" class="mb-2">
          <v-expansion-panel-header>
            <template v-slot:actions>
              <v-icon color="dark">mdi-chevron-down</v-icon>
            </template>
            {{hubbdata.home.labels.providers}}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-for="(favourite, idx) in organisations" :key="idx">
              <OrganisationItem
                  v-if="favourite.type != null && favourite.type == 'organisation'"
                  :key="idx"
                  :organisation = favourite
                />
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel @click="scrollToTop()" ripple v-if="cms_pages.length" class="mb-2">
            <v-expansion-panel-header>
              <template v-slot:actions>
                <v-icon color="dark">mdi-chevron-down</v-icon>
              </template>
              {{hubbdata.home.labels.info}}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-for="(favourite, idx) in cms_pages" :key="idx">
                <CmsPageItem
                  v-if="favourite.type != null && favourite.type == 'cms_page'"
                  :key="idx"
                  :cms_page = favourite
                />
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </div>
</template>

<script>
import favourites from "@/favourites";
import OpportunityItem from '@/components/Opportunities/OpportunityItem.vue';
import OrganisationItem from '@/components/Organisations/OrganisationItem.vue';
import CmsPageItem from '@/components/Cms/CmsPageItem.vue';
import smoothscroll from 'smoothscroll-polyfill';
import EventItem from '@/components/Events/EventItem.vue';
import hubbdata from "@/hubbdata";

export default {
  name: 'Favourites',
  data() {
    return {
        addToFavourites(item) {
            favourites.commit("addFavourite", item)
        },
        removeFromFavourites(item) {
            favourites.commit("removeFavourite", item)
        },
    }
  },
  components: {
    EventItem,
    OpportunityItem,
    OrganisationItem,
    CmsPageItem

  },
  computed: {
    favourites() {
      return favourites.state.favourites;
    },
    events() {
      return favourites.state.favourites.filter(favourite => favourite.type === 'event');
    },
    opportunitys() {
      return favourites.state.favourites.filter(favourite => favourite.type === 'opportunity');
    },
    organisations() {
      return favourites.state.favourites.filter(favourite => favourite.type === 'organisation');
    },
    cms_pages() {
      return favourites.state.favourites.filter(favourite => favourite.type === 'cms_page');
    },
    hubbdata() {
      return hubbdata.getters.translations;
    },
  },
  methods: {

      scrollToTop() {
        smoothscroll.polyfill();
        let extraHeight = 0
        let child_pages


         if (document.getElementsByClassName("child-pages").length !== 0) {
            child_pages = document.getElementsByClassName("child-pages")[0].offsetHeight
         }
         else {
            child_pages = 0
         }
        setTimeout(() => {
          window.scrollTo({
            top: document.getElementsByClassName("cms-content")[0].offsetHeight + child_pages + extraHeight,
            behavior: 'smooth'

          })
        }, 300);



      },
  },
};
</script>

<style lang="scss">
.v-expansion-panel-content__wrap {
  padding: 0px !important;
  margin-top: 0px;
}

.v-expansion-panel-content {
  margin-top: 0px !important;
}

@media screen and (min-width: 960px) {

  .favourite__logo {
    height: 300px;
    .v-image__image--contain {
      height: 300px;
      background-size: cover !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.v-list-item__chevron {
  right: 20px;
}

.expansion-panel{
  margin-bottom: 20px;
}

.cms-content {
  text-align: center;
  padding: 20px 20px 10px 20px;

  &__header {
    font-size:40px;
    padding-bottom: 20px;
  }

  &__data {
    font-size: 16px;
    text-align: center;
  }
}

.v-expansion-panel-content__wrap {
  padding: 0px ;

  div article {
    margin: 0 auto!important;
    margin-top: 10px!important;
    margin-bottom: 10px!important;
  }
}

.no-favourites {
  font-size: 17px;
  text-align: center;
}

.v-icon {
  color: white;
  font-size: 40px;
}

.v-expansion-panel-header {
  background-color: #f4f4f4 !important;
  color: $dark!important;
  text-transform: capitalize;
  text-align: center;
  padding: 30px;
  margin-bottom: 1px;
  font-size: 22px;
  border-radius: 0px;
  font-weight: 700;

  &:focus {
    outline: 2px solid $black;
    outline-offset: 2px;
  }

  i {
    color: $dark;
    font-size: 40px;
  }
}

.child-pages {

  &__list {
    padding: 0px 20px 20px 20px;
    width: 100%
  }

  &__list-item {
    list-style: none;
    padding: 20px 20px 20px 20px;
    text-align:center;
    margin-bottom: 20px;
  }

  &__link {
    text-decoration: none;
    font-size: 22px;
  }
}

.tile-list__icon {
  background-color: #00aeef;
  margin: -40px 0px 10px 0px;
}

.child-pages {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 40px;
}

.v-expansion-panel-content {
  margin-top: 25px;
}

.v-expansion-panel-content {
  @media screen and (min-width: 960px) {
    width: 750px;
    margin: auto;
  }
}
</style>